import { ModalComponent } from './modal.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  exports: [ModalComponent],
  imports: [ModalComponent],
})
export class ModalModule {}
